// TypingText.jsx
import React, { useState, useEffect } from "react";

export default function TypingText({
  words = ["Metal", "AI"],
  colors = ["#1579be", "#e63946"], // <-- new
  typingSpeed = 200,
  deletingSpeed = 200,
  pauseDelay = 1500,
}) {
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [phase, setPhase] = useState("typing");

  useEffect(() => {
    let timeout;
    const current = words[wordIndex] || "";

    if (phase === "typing") {
      if (charIndex < current.length) {
        timeout = setTimeout(() => setCharIndex((c) => c + 1), typingSpeed);
      } else {
        timeout = setTimeout(() => setPhase("deleting"), pauseDelay);
      }
    } else if (phase === "deleting") {
      if (charIndex > 0) {
        timeout = setTimeout(() => setCharIndex((c) => c - 1), deletingSpeed);
      } else {
        setPhase("typing");
        setWordIndex((i) => (i + 1) % words.length);
      }
    }

    return () => clearTimeout(timeout);
  }, [
    words,
    wordIndex,
    charIndex,
    phase,
    typingSpeed,
    deletingSpeed,
    pauseDelay,
  ]);

  // pick the color for this word (fallback to first)
  const color = colors[wordIndex] || colors[0];
  const displayText = (words[wordIndex] || "").substring(0, charIndex);

  return (
    <span className="typing" style={{ color }}>
      {displayText}
      <span className="cursor" />
    </span>
  );
}
